import {NgModule} from '@angular/core';
import {IonicModule} from 'ionic-angular';
import {BodyInputModule} from '../body.module';
import {BodyInputModalComponent} from './body-input-modal.component';

/**
 * Module for the BodyInputModalModule
 * @class
 */
@NgModule({
  declarations: [BodyInputModalComponent],
  entryComponents: [BodyInputModalComponent],
  exports: [BodyInputModalComponent],
  imports: [IonicModule, BodyInputModule],
  providers: [],
})
export class BodyInputModalModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/body-input-modal/body-input-modal.component.module.ts